import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Storage } from 'landings/storage';
import { RemoteProps } from './widgets-types';

export const StorageRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Storage />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
